import { render, staticRenderFns } from "./classDetail.vue?vue&type=template&id=3ecceeb1&scoped=true&"
import script from "./classDetail.vue?vue&type=script&lang=ts&"
export * from "./classDetail.vue?vue&type=script&lang=ts&"
import style0 from "./classDetail.vue?vue&type=style&index=0&id=3ecceeb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecceeb1",
  null
  
)

export default component.exports